import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import Table from "../../common/Table/table";
import {
  getAllBranchByClinic,
  getbranchforclinicSlice,
} from "../../../store/slices/branchSlice";

import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import {
  updateClinic,
  resetUpdateClinicMessage,
} from "../../../store/slices/clinicSlice";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";

const Branch = () => {
  const [formData, setFormData] = useState({
    branch: [],
    branchName: [],
  });
  const [searchValue, setSearchValue] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();

  const {
    branchByclinic,
    branches,
    searchBranchErrorMessage,
    currentPage,
    totalPages,
    totalCount,
    loading,
  } = useSelector((state) => state.branches);

  const { clinicInfo, updateClinicErrorMessage, updateClinicSuccessMessage } =
    useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const clinicId = clinicInfo?.[0]?.clinicId ;


  const fetchBranches = useCallback(
    (page = 1, limit = pageLimit, search = searchValue) => {
      if (!clinicId || !token) return;

      dispatch(
        getAllBranchByClinic({
          parentClinicId: clinicId,
          clinicStatus: ["Active"],
          token,
          currentPage: page,
          limit,
          search: search || "",
        }),
      );
    },
    [clinicId, dispatch, token, pageLimit, searchValue],
  );

  useEffect(() => {
    fetchBranches();
    if (clinicId) {
      dispatch(
        getbranchforclinicSlice({
          excludeClinicId: clinicId,
          loginRole: "ClinicAdmin",
          status: ["Active"],
          token,
        }),
      );
    }
  }, [clinicId, dispatch, showAddModal, token, fetchBranches]);

  useEffect(() => {
    showTostifyMessageAndReset(
      updateClinicSuccessMessage,
      showToastifySuccess,
      resetUpdateClinicMessage,
    );
    showTostifyMessageAndReset(
      updateClinicErrorMessage,
      showToastifyError,
      resetUpdateClinicMessage,
    );
  }, [
    updateClinicSuccessMessage,
    updateClinicErrorMessage,
    dispatch,
    showTostifyMessageAndReset,
  ]);


  useEffect(() => {
    if (clinicInfo?.[0]?.branch) {
      setFormData((prevState) => ({
        ...prevState,
        userId: clinicInfo[0]?.userId?._id,
        branch: clinicInfo[0].branch.map((data) => data),
        branchName: clinicInfo[0].branch.map((data) => ({
          value: data,
          label:
            branches?.find((branch) => branch.branchId === data)?.branchName ||
            "Branch",
        })),
      }));
    }
  }, [clinicInfo, branches]);

  const tableHead = [
    { title: "Branch Name", key: "branchName" },
    { title: "Branch Request", key: "branchRequest" },
  ];

  const handleBranchChange = (selectedOption) => {
    const newItem = selectedOption || [];
    const newBranchIds = newItem.map((data) => data.value);
    const updatedBranches = Array.from(
      new Set([...(formData?.branch || []), ...newBranchIds]),
    );
    setFormData((prevState) => ({
      ...prevState,
      branch: updatedBranches,
      branchName: newItem,
    }));
  };

  const handleUpdateClinic = async (e) => {
    e.preventDefault();
    try {
      await dispatch(
        updateClinic({
          ...formData,
          admindUrl: process.env.PUBLIC_BASE_URL,
          pageName: "login",
          token,
        }),
      );
    } catch (error) {}
    setShowAddModal(false);
  };

  const handlePageChange = (page) => {
    fetchBranches(page, pageLimit, searchValue);
  };

  const handleLimitChange = (limit) => {
    setPageLimit(limit);
    fetchBranches(1, limit, searchValue);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    fetchBranches(1, pageLimit, value);
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <button
          className="btn btn-success me-2"
          onClick={() => setShowAddModal(true)}
        >
          Branch Request
        </button>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/RequestBranch")}
        >
          Check Branch Request
        </button>
      </div>

      <Table
        tableHead={tableHead}
        tableBody={
          branchByclinic &&
          branchByclinic?.flatMap((item) =>
            item.branchClinicId?.map((branch) => ({
              id: branch?._id,
              branchName: branch?.clinicId?.clinicName || "N/A",
              branchRequest: branch?.branchRequest || "N/A",
            })),
          )
        }
        searchValue={searchValue}
        handleSearch={handleSearch}
        errorMessage={searchBranchErrorMessage}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading={loading}
      />

      <Modal
        centered
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        size="md"
      >
        <div className="modal-header">
          <h5 className="modal-title">Branch Request</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowAddModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleUpdateClinic}>
            <div className="mb-3">
              <label className="col-form-label">Branch</label>
              <Select
                isMulti
                placeholder="Please select branch"
                value={formData.branchName}
                onChange={handleBranchChange}
                options={branches?.map((item) => ({
                  value: item.branchId,
                  label: item.branchName,
                }))}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowAddModal(false)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-success">
                Add
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default Branch;
